export enum QUEUEID {
  Salg = "gjewcbDKPSalgGj",
  PrivatForsikring = "gjeDKPWCBKRGJ",
  SundhedsForsikring = "gjedkwcbsundhed",
  Bil = "gjedkwcbcbil",
  IndboHusKaeledyr = "gjedkwcbcindhus",
  Rejse = "gjedkwcbcrejse",
  Ulykke = "gjedkwcbulykke",
  Ejerskifte = "gjedkwcbcejer",
}
